import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { TimeSheetStatus } from "@/v2/types/DraftedTimeSheet";

const STATUS_COLOR: Record<TimeSheetStatus, string> = {
    DRAFTED: "bg-gray-100 text-gray-700 border-gray-200",
    TO_BE_VERIFIED: "bg-yellow-100 text-yellow-800 border-yellow-200",
    VERIFIED: "bg-blue-100 text-blue-800 border-blue-200",
    APPROVED: "bg-green-100 text-green-800 border-green-200",
    REJECTED: "bg-red-100 text-red-800 border-red-200",
};

const STATUS_LABELS: Record<TimeSheetStatus, string> = {
    DRAFTED: "Drafted",
    TO_BE_VERIFIED: "To Be Verified",
    VERIFIED: "Verified",
    APPROVED: "Approved",
    REJECTED: "Need Change",
};

export default function TimeSheetStatusBadge({
    status,
    className,
}: {
    status?: TimeSheetStatus | null;
    className?: string;
}) {
    if (!status || !STATUS_LABELS[status]) {
        return <span className="text-sm text-muted-foreground">N/A</span>;
    }

    return (
        <Badge
            variant="outline"
            className={cn(
                "whitespace-nowrap font-medium hover:bg-inherit",
                STATUS_COLOR[status],
                className,
            )}
        >
            {STATUS_LABELS[status]}
        </Badge>
    );
}
